import React from "react";

export class ActiveFormatter extends React.Component {
    render() {
        return (
            <span className={this.props.active ? "fas fa-check" : "far fa-square"} />
        );
    }
}